<compartido-ficha [configuracion]="configFicha" *ngIf="orden">
  <div
    class="orden borde mat-app-background {{
      responsiveService.claseCSS$ | async
    }}"
  >
    <mat-list>
      <!-- Detalles -->
      <mat-list-item>
        <mat-icon matListItemIcon>location_on</mat-icon>
        <h3 matListItemTitle>ID Orden</h3>
        <p matListItemLine>{{ orden.id }}</p>
      </mat-list-item>
      <mat-list-item *ngIf="orden.domicilio">
        <mat-icon matListItemIcon>receipt</mat-icon>
        <h3 matListItemTitle>ID Domicilio</h3>
        <p matListItemLine>{{ orden.domicilio }}</p>
      </mat-list-item>
      <mat-list-item *ngIf="orden.referencia">
        <mat-icon matListItemIcon>numbers</mat-icon>
        <h3 matListItemTitle>No. Referencia</h3>
        <p matListItemLine>{{ orden.referencia }}</p>
      </mat-list-item>
      <mat-list-item>
        <mat-icon matListItemIcon>person</mat-icon>
        <h3 matListItemTitle>Cliente</h3>
        <p matListItemLine>
          {{ orden.cliente.nombre }} -
          {{ orden.cliente.identificacion }}
        </p>
      </mat-list-item>
    </mat-list>
  </div>

  <compartido-formulario
    class="formulario"
    [configuracion]="configFormulario"
    (valores)="valorFormulario = $event"
    (valido)="validezFormulario = $event"
  ></compartido-formulario>

  <div class="botones">
    <button
      mat-flat-button
      color="warn"
      (click)="cancelarOrden()"
      [disabled]="!validezFormulario || cargando()"
      [class.cargando]="cargando()"
    >
      Cancelar Orden <mat-icon>close</mat-icon>
    </button>
  </div>
</compartido-ficha>

<div class="cargando" *ngIf="cargando()">
  <mat-spinner diameter="50"></mat-spinner>
</div>

<div class="sin-datos" *ngIf="!cargando() && orden === undefined">
  <mat-icon>info</mat-icon>
  <span>No se encontraron datos de la orden.</span>
</div>
